import React from 'react'
import { isClient } from '../../../../helpers'
import { withParsedContext } from '../../withJSSContext'

interface Props {
  pageEditing: boolean

  parsedFields: {
    name: string
    channel: string
    language: string
    template: string
    platform: string
    status: string
    guid: string
  }
}

const MagazinesStoriesArchiveAnalytics: React.FC<Props> = ({ parsedFields, pageEditing }) => {
  if (isClient && !pageEditing) {
    window.AnalyticsDataLayer = window.AnalyticsDataLayer || {}
    window.AnalyticsDataLayer.page = window.AnalyticsDataLayer.page || {}
    window.AnalyticsDataLayer.platform = window.AnalyticsDataLayer.platform || {}
    window.AnalyticsDataLayer.user = window.AnalyticsDataLayer.user || {}

    window.AnalyticsDataLayer.page.name = parsedFields?.['name']
    window.AnalyticsDataLayer.page.channel = parsedFields?.['channel']
    window.AnalyticsDataLayer.page.language = parsedFields?.['language']
    window.AnalyticsDataLayer.page.template = parsedFields?.['template']

    window.AnalyticsDataLayer.platform.name = parsedFields?.['platform']

    window.AnalyticsDataLayer.user.status = parsedFields?.['status']
    window.AnalyticsDataLayer.user.GUID = parsedFields?.['guid']
  }

  return null
}

export default withParsedContext(MagazinesStoriesArchiveAnalytics as React.FC)
